import { ReactNode } from "react";
import { MoreHorizontal } from "lucide-react";
import { Button } from "~/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "~/components/ui/dropdown-menu";
import { cn } from "~/lib/utils";

interface OverflowMenuProps {
  /** DropdownMenuItem / DropdownMenuSeparator children. */
  children: ReactNode;
  /** Names what the menu acts on, for its accessible label. */
  label?: string;
  className?: string;
}

/**
 * The "…" button beside the primary overview actions, holding the commands that
 * don't earn their own button. Matches the Favorite button's height.
 */
export function OverflowMenu({ children, label = "actions", className }: OverflowMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="icon"
          aria-label={`More ${label}`}
          className={cn("shadow-xs", className)}
        >
          <MoreHorizontal className="size-4" aria-hidden="true" />
        </Button>
      </DropdownMenuTrigger>
      {/* min-w, not w: a fixed width wraps any item longer than it. */}
      <DropdownMenuContent align="end" className="min-w-48 [&_[role=menuitem]]:whitespace-nowrap">
        {children}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
